import React from 'react'
import SearchProvider from '../../../contexts/SearchContext'
import { observer } from 'mobx-react-lite'
import InfluencersContent from './InfluencersContent'

export default observer(function Influencers() {
  return (
    <SearchProvider>
      <InfluencersContent />
    </SearchProvider>
  )
})
